export default __webpack_public_path__ + "static/MUMMY_scaled-25f2d6d6583cf98a5a1f5705c1b01ec5.gif";